import { render, staticRenderFns } from "./single-mb.vue?vue&type=template&id=72de4e28&scoped=true&"
import script from "./single-mb.vue?vue&type=script&lang=js&"
export * from "./single-mb.vue?vue&type=script&lang=js&"
import style0 from "./single-mb.vue?vue&type=style&index=0&id=72de4e28&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72de4e28",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/SvgIcon.vue').default})
